const ROOT = 'modal';

export const OPEN_MODAL = `${ROOT}/OPEN_MODAL`;
export const CLOSE_MODAL = `${ROOT}/CLOSE_MODAL`;
